import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/(main)/(dashboard)/page.tsx");
